<template>
  <div
    class="description-editor"
    :class="{
      isLocked, showLockIcon, isTemplate, isFlagship,
    }"
  >
    <div
      v-if="showLockIcon"
      class="lock-icon-container"
    >
      <LockIcon
        :is-editable="allowLockToggle"
        :is-active="isLocked"
        :is-template="isTemplate"
        :is-flagship="isFlagship"
        @click="$emit('toggleLock', $event)"
      />
    </div>
    <NoParagraphEditor
      v-if="disabledNodes.paragraph"
      v-bind="{ ...$props, ...$attrs }"
      @link-edit="$emit('linkEdit', $event)"
      @show-apply-template="$emit('showApplyTemplate', $event)"
      @ai-suggest-click="$emit('aiSuggestClick', $event)"
      @add-editor="$emit('addEditor', $event)"
      @blur-editor="$emit('blurEditor', $event)"
      @remove-editor="$emit('removeEditor', $event)"
      @update-selected-json="$emit('updateSelectedJson', $event)"
      @focus-editor="$emit('focusEditor', $event)"
    />
    <TiptapWrap
      v-else
      v-bind="{ ...$props, ...$attrs }"
      @link-edit="$emit('linkEdit', $event)"
      @show-apply-template="$emit('showApplyTemplate', $event)"
      @ai-suggest-click="$emit('aiSuggestClick', $event)"
      @add-editor="$emit('addEditor', $event)"
      @blur-editor="$emit('blurEditor', $event)"
      @remove-editor="$emit('removeEditor', $event)"
      @update-selected-json="$emit('updateSelectedJson', $event)"
      @focus-editor="$emit('focusEditor', $event)"
    />
  </div>
</template>

<script>
import TiptapWrap from '@ui/components/editor/TiptapWrap/TiptapWrap.vue';
import { tiptapWrapProps } from '@ui/components/editor/TiptapWrap/tiptapWrapProps';
import LockIcon from '@ui/components/editor/LockIcon/LockIcon.vue';
import NoParagraphEditor from '@ui/components/editor/NoParagraphEditor/NoParagraphEditor.vue';

export default {
  name: 'DescriptionEditor',
  components: { LockIcon, NoParagraphEditor, TiptapWrap },
  props: {
    ...tiptapWrapProps,
    showLockIcon: { type: Boolean, default: false },
    allowLockToggle: { type: Boolean, default: false },
    isTemplate: { type: Boolean, default: false },
    isFlagship: { type: Boolean, default: false },
  },
  emits: [
    'toggleLock',
    'linkEdit',
    'aiSuggestClick',
    'showApplyTemplate',
    'addEditor',
    'blurEditor',
    'removeEditor',
    'updateSelectedJson',
    'focusEditor',
  ],
};
</script>

<style scoped lang="less">
.description-editor {
  border-radius: 5px;

  width: 87%;
  .lock-icon-container {
    top: 8px;
  }

  &.isLocked {
    background-color: fade(@bg-brand-default, 5%);
  }

  &.isTemplate.isLocked:not(.showLockIcon) {
    background-color: fade(@bg-brand-default, 2%);
  }

  &.isFlagship.isLocked:not(.showLockIcon) {
    background-color: fade(@bg-brand-default, 2%);
  }

  .lock-icon-container {
    position: relative;
    top: 4px;
    left: calc(100% + 12px);
    width: 0;
    height: 0;
  }
}
</style>
